module.exports = __webpack_public_path__ + "static/media/ic-delete-active.820fa649.svg";